<div class="lead-container">
  <lib-loading id="loading" *ngIf="screenLoading"></lib-loading>
  <!-- BUSCA SUPERIOR -->
  <div class="lead-search" *ngIf="listCampaign.length && !screenLoading">
    <div class="autoCompWrap">
      <app-autocomplete
        [isMkt]="true"
        maxLength="200"
        value="label"
        placeholder="Buscar campanhas"
        inputId="campaign-autocomplete"
        [autoSearchResults]="autocomplete"
        (toggleClearButton)="toggleClearButton($event)"
        (autocompleteSearch)="searchElement($event)"
        (ElementSelected)="elementSelected($event)"
        [loading]="loading"
        >
      </app-autocomplete>
      
      <span *ngIf="showClearButton" id="resetAutocompleteButton" (click)="resetSearch()">Limpar</span>
    </div>
    
    <div class="element" *ngIf="isAutocomplete">
      <ul class="select">
        <li *ngFor="let item of lead_list_search; let i = index">
          <a id="list-tags-{{i}}">
            <!-- <span class="select-description" [innerHTML]="item.label"></span> -->
            <!-- <p>{{ item.title }}</p> -->
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="no-campaign" *ngIf="!listCampaign.length && !screenLoading">
    <span>No momento não existem campanhas disponíveis para você se inscrever.</span>
  </div>

  <!-- CARDS -->
  <div class="container-cards">
    <div class="cards" *ngIf="listCampaign.length && !screenLoading">
      <p>Campanhas em oferta</p>
      <div *ngFor="let data of listCampaign">
        <app-lead-offer-card [campaign]="data"
          (showModalParticipants)="showModalParticipants($event, data)"
          (showSummaryModal)="showSummaryModal($event, data)"
          [isLoading]="isLoading">
        </app-lead-offer-card>
      </div>
    </div>
    <span class="text-element">Para acessar mais campanhas, <a class="link" rel="noopener noreferrer" href="https://www.lopes.com.br/campanha/lopes-leads" target="_blank">clique aqui.</a> </span>
  </div>
</div>

<app-application-summary *ngIf="isSummary" 
  [campaign]="summaryCampaign"
  [isSummary]="isSummary"
  (closeSummary)="closeSummary($event)">
</app-application-summary>

<app-modal-participate *ngIf="isParticipate" [isParticipate]="isParticipate" [campaign]="campaign"
  (closeParticipants)="showModalParticipants($event)" (finished)="finished($event)"></app-modal-participate>

<app-lead-confirm *ngIf="openConfirm" [openConfirm]="openConfirm" (confimClose)="finished($event)"></app-lead-confirm>